import { useAbility } from '@/hooks/useAbility';

/**
 * Whether the viewer may start a support thread with a member, which is what
 * the inbox's new-message button offers. The server grants it to the Primum
 * Support account only, and rules follow the effective user, so this is true
 * exactly while staff act as Primum Support. False until rules arrive.
 */
export function useCanStartSupportThread(): boolean {
  return useAbility().can('create', 'SupportThread');
}

/**
 * Whether the viewer may list a member's recent inquiries, which is what the
 * support composer's attach control offers. Granted to the `primum` group and
 * to the Primum Support account, so it holds for staff acting as support even
 * though act-as drops Cognito groups. False until rules arrive.
 */
export function useCanReadUserInquiries(): boolean {
  return useAbility().can('read', 'UserInquiries');
}

/**
 * Whether the viewer may share a survey into a member's support thread, which
 * is what the support composer's survey option offers. The server grants it to
 * the Primum Support account only, for a published survey, so this is true
 * exactly while staff act as Primum Support. False until rules arrive.
 */
export function useCanShareSurvey(): boolean {
  return useAbility().can('share', 'Survey');
}
